import React, { useState } from "react";
import Button from "../../../components/ACS-Dashboard/ACS-Blocks/Button";
import FilterButton from "../../../components/ACS-Dashboard/ACS-Blocks/FilterButton";
import Tabs from "../../../components/ACS-Dashboard/ACS-Blocks/Tabs";
import OrdersTableIncoming from "./TabContent/OrdersTableIncoming";
import SearchBox from "../../../components/ACS-Dashboard/ACS-Blocks/SearchBox";
import OrderHistory from "./TabContent/OrderHistory";
import NewOrder from "./TabContent/NewOrder";
import TemplatesOrders from "./TabContent/TemplatesOrders";
import { useSelector, useDispatch } from "react-redux";
import {
  addTab,
  removeTab,
  setActiveTab,
  setStatusFilter as setOrdersStatusFilter,
} from "../../../redux/slices/ordersSlice";
import { selectModuleTabs } from "../../../redux/selectors/tabsSelectors";
import { FiSearch, FiChevronDown } from "react-icons/fi";
import PendingOrders from "./TabContent/PendingOrders";
import CompletedOrders from "./TabContent/CompletedOrders";
import OrdersSearchSubTabs from "./TabContent/OrdersSearchResult";
import OrderDetailsView from "./TabContent/OrderDetailsView";

const moduleName = "orders";
const DEFAULT_STATUS_FILTER = "New";

const OrdersDetails = () => {
  const dispatch = useDispatch();
  const { tabs, activeTab, defaultTabsCount } = useSelector(
    selectModuleTabs(moduleName)
  );
  const statusFilterFromStore = useSelector(
    (state) => state.orders.statusFilter
  );
  const statusFilter =
    statusFilterFromStore === undefined
      ? DEFAULT_STATUS_FILTER
      : statusFilterFromStore;

  // ✅ Manage search query & filters
  const [searchQuery, setSearchQuery] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(false); // ✅ Force fetch when search button is clicked
  const [totalOrders, setTotalOrders] = useState(0); // ✅ Track total orders

  const statusOptions = ["New", "Cancelled", "Planned", "Completed",];

  // ✅ Handle search button click
  // const handleSearch = () => {
  //   setSearchTrigger((prev) => !prev); // Toggle state to trigger API call
  // };

  const handleSearch = () => {
    if (!searchQuery.trim()) return;

    // Create a unique id for the search tab and provide custom name/content.
    const newTabId = `search-${Date.now()}`;
    dispatch(
      addTab({
        id: newTabId,
        name: `Search: ${searchQuery}`,
        // Optionally, add a component or other identifier for the UI to render search results.
        // For example, you might add a field like `contentType: 'searchResults'` or even a component.
        contentType: "searchResults",
        searchQuery,
        isDynamic: true,
        createdAt: Date.now(),
      })
    );
    // dispatch(setActiveTab({ index: state.defaultTabs.length + state.dynamicTabs.length })); // Adjust as needed
  };

  // ✅ Handle status filter change
  const handleStatusFilter = (selectedValue) => {
    const nextValue =
      selectedValue === "All Statuses" ? null : selectedValue || null;
    dispatch(setOrdersStatusFilter(nextValue));
  };

  // ✅ Clear filters
  const handleClearFilters = () => {
    setSearchQuery("");
    dispatch(setOrdersStatusFilter(DEFAULT_STATUS_FILTER));
    setSearchTrigger((prev) => !prev); // ✅ Force fetch with cleared filters
  };

  // ✅ Default tab content
  const defaultTabContents = {
    orders: (
      <OrdersTableIncoming
        key="orders"
        searchQuery=""
        statusFilter={statusFilter}
        searchTrigger={searchTrigger} // ✅ Pass trigger to refetch
        setTotalOrders={setTotalOrders} // ✅ Update total orders count
        statusOptions={["New", "Cancelled", "Planned", "Completed"]}
      />
    ),
    // "templates-orders": <TemplatesOrders key="templates-orders" />,
    // "order-history": <OrderHistory key="order-history" />,
    // "pending-orders": <PendingOrders key="pending-orders" />,
    // "completed-orders": <CompletedOrders key="completed-orders" />,
  };

  // ✅ Handle tab add & remove
  // const handleAddTab = () => dispatch(addTab({ module: moduleName }));

  const handleAddTab = () => {
    dispatch(addTab());
  };

  const handleRemoveTab = (index) => {
    if (index < defaultTabsCount) {
      alert("Default tabs cannot be removed.");
      return;
    }
    dispatch(removeTab({ module: moduleName, tabIndex: index }));
  };

  return (
    <div className="p-fluid-1 shadow-md flex flex-col flex-1 h-full min-h-0 overflow-hidden">
      {/* Top Action/Filter Bar */}
      <div className="flex flex-wrap justify-between items-center rounded-md ml-[2] p-fluid-1">
        <div className="flex flex-wrap items-center gap-2">
          {/* ✅ Status Dropdown Filter */}
          <FilterButton
            text={statusFilter ? statusFilter : "Status Filter"} // Show selected value
            options={["All Statuses", ...statusOptions]} // Dropdown options
            selectedValue={statusFilter || "All Statuses"}
            onSelect={handleStatusFilter} // Call the handler when selecting an option
          />
          {/* ✅ Clear Filters Button */}
          {/* <FilterButton
            text="Clear Filters"
            backgroundColor="gray"
            textColor="black"
            onClick={handleClearFilters}
          /> */}

          {/* ✅ Search Box + Total Orders Count */}
          <SearchBox
            value={searchQuery}
            onChange={setSearchQuery}
            onSearch={handleSearch}
            placeholder="Search Orders"
          />

            <button
              onClick={handleSearch}
              className="absolute right-3 text-gray-500 dark:text-acs-dark-subtext 
                      hover:text-[#223688] dark:hover:text-acs-dark-hover transition-none"
            >
            </button>

          {/* ✅ Total Orders Display (Next to Search Box) */}
          <span className="text-gray-500 text-fluid-sm font-semibold text-acs-light-text dark:text-acs-dark-text">
            {totalOrders} {totalOrders === 1 ? "Order" : "Orders"}
          </span>
        </div>

        {/* 🔹 Actions */}
        <div className="flex items-center gap-2">
          <div className="p-2 rounded-md hover:bg-gray-100 transition cursor-pointer"></div>
          <Button
            text="Create Orders"
            // onClick={handleAddTab}
            backgroundColor="#223688"
            textColor="white"
            fontSize="14px"
            padding="10px 18px"
            borderRadius="24px"
          />
        </div>
      </div>

      {/* 🔹 Tabs Component */}
      <div className="flex-1 mt-fluid-2 min-h-0 flex flex-col overflow-hidden">
        <Tabs
          moduleName={moduleName}
          tabs={tabs.map((tab) => tab.name)}
          tabContents={tabs.map((tab) => {
            if (tab.contentType === "searchResults") {
              return (
                <OrdersSearchSubTabs
                  key={tab.id}
                  searchQuery={tab.searchQuery || ""}
                  statusFilter={statusFilter}
                  searchTrigger={searchTrigger} // ✅ Pass trigger to refetch
                  setTotalOrders={setTotalOrders} // ✅ Update total orders count
                />
              );
            }

            if (tab.contentType === "orderView") {
              return (
                <OrderDetailsView
                  key={tab.id}
                  orderNumber={tab.orderNumber}
                  orderOfficeCode={tab.orderOfficeCode}
                />
              );
            }
            return (
              defaultTabContents[tab.id] || (
                <NewOrder
                  key={tab.id}
                  title={tab.name}
                  tabId={tab.id}
                  isDynamic={tab.isDynamic}
                />
              )
            );
          })}
          activeTab={activeTab}
          onTabChange={(index) =>
            dispatch(setActiveTab({ module: moduleName, index }))
          }
          isDeletable={tabs.map((_, index) => index >= defaultTabsCount)}
          onRemoveTab={handleRemoveTab}
          aria-label="Inventory tabs"
        />
      </div>
    </div>
  );
};

export default OrdersDetails;